import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./client";
import { Flower, FlowerParams, FlowerUpdate } from "../@type/flowerType";

class FlowerService {
  get = async (params?: FlowerParams): Promise<AxiosResponse> => {
    try {
      let url = "flowers/filter";

      // Nếu có params, build query string thủ công
      if (params && Object.keys(params).length > 0) {
        const query = Object.entries(params)
          .filter(([_, value]) => value !== undefined && value !== null && value !== "") // loại bỏ undefined/null/empty
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");

        if (query) {
          url += `?${query}`;
        }
      }

      const response = await getAsync(url);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  getById = async (flowerId: number): Promise<AxiosResponse> => {
    return await getAsync(`flowers/${flowerId}`);
  };

  post = async (data: Flower): Promise<AxiosResponse> => {
    return await postAsync("flowers", data);
  };

  put = async (id: number, data: FlowerUpdate): Promise<AxiosResponse> => {
    return await putAsync(`flowers/${id}`, data);
  };

  delete = async (_id: number): Promise<AxiosResponse> => {
    return await deleteAsync(`flowers/${_id}`);
  };
  deleteImage = async (id: number): Promise<AxiosResponse> => {
    return await deleteAsync(`images/${id}`);
  };
}

const flowerService = new FlowerService();
export default flowerService;

